import { Link } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthProvider";
import { useStoreContext } from "../../contexts/StoreProvider";
import styles from "./index.module.scss";

const Footer = () => {
  const {
    state: { user, externalUrls },
  } = useStoreContext();
  const { logout } = useAuthContext();
  const handleLogout = () => {
    logout();
  };
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.copyright}>
          &copy; {new Date().getFullYear()} Motion LP
        </div>
        <nav className={styles.nav}>
          <a
            href={externalUrls.motion_accessibility_policy}
            className={styles["nav-item"]}
            target="_blank"
            rel="noopener noreferrer"
          >
            Accessibility Policy
          </a>
          <a
            href={externalUrls.motion_privacy_policy}
            className={styles["nav-item"]}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          {user ? (
            <button
              type="button"
              className={styles["nav-item"]}
              onClick={handleLogout}
            >
              Log Out
            </button>
          ) : (
            <Link to="/login" className={styles["nav-item"]}>
              Login
            </Link>
          )}
        </nav>
      </div>
    </footer>
  );
};
export default Footer;
